import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import api from '../../../../utils/api';

export default function RegisterCompanyModal({ visible, onCancel, onSuccess }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const payload = {
        nameCn: values.nameCn,
        nameEn: values.nameEn,
        licenseNumber: values.licenseNumber,
        capital: values.capital,
        address_: values.address_,
        // offshore: 0 // Default
      };

      const res = await api.post('/approvals/submit', {
        type: 'CREATE_COMPANY',
        payload: JSON.stringify(payload),
        remark: values.remark
      });

      if (res && res.code === 200) {
        message.success('企业登记申请已提交');
        onSuccess();
        onCancel();
      } else {
        message.error(res.message || '提交失败');
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="登记企业"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>取消</Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}>提交申请</Button>
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item label="企业中文名" name="nameCn" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="企业英文名" name="nameEn">
          <Input />
        </Form.Item>
        <Form.Item label="统一社会信用代码" name="licenseNumber" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="注册资本" name="capital">
          <Input />
        </Form.Item>
        <Form.Item label="注册地址" name="address_">
          <Input />
        </Form.Item>
        <Form.Item label="申请备注" name="remark">
          <Input.TextArea rows={2} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
